// useSessionDetails.js

import { useSelector } from 'react-redux';

const useSessionDetails = () => {
  // Access the relevant slice of state
  const storeSel = useSelector((state) => state.UrlData); // Adjust according to your root reducer

  // Extract session content from the store
  const sessionTrialContent = storeSel.sessionTrialList?.sessionsTrial || [];
  const sessionContent = storeSel.sessionList?.sessions || [];

  // Get the currently selected session type
  const selectedSessionType = storeSel.userDetails?.isTrial || '';

  // Find the indices for the selected options based on the plan name
  const selectedTrialOption = sessionTrialContent.findIndex((sess) => sess?.sessionid === storeSel?.userDetails?.sessionid);
  const selectedOption = sessionContent.findIndex((sess) => sess?.sessionid === storeSel?.userDetails?.sessionid);

  // Extract the desired values
  // const isTrial = selectedSessionType.startsWith("trial_");
    

  console.log('selected trial option', selectedTrialOption);
  console.log('selected option', selectedOption);

  const isTrial = storeSel.userDetails?.isTrial;
  const trialDaysTime = isTrial ? sessionTrialContent[selectedTrialOption]?.daystime : null;
  const paidDaysTime = !isTrial ? sessionContent[selectedOption]?.daystime : null;

  // Return the specific values
  return {
    isTrial,
    trialDaysTime,
    paidDaysTime,
  };



};

export default useSessionDetails;
